<template>
  <footer class="mainfooter mt-auto" role="contentinfo">
    <div class="footer-middle">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-6">
            <!--Column1-->
            <div class="footer-pad">
              <h4>
                <img src="@/assets/images/logo.png" alt="logo" height="30" />
              </h4>
              <ul class="list-unstyled">
                <li><a href="#"></a></li>
                <li><router-link to="/">Home</router-link></li>
                <li><router-link to="all-games">Games</router-link></li>
                <!-- <li><router-link to="how-to-pay">How to Pay</router-link></li> -->
              </ul>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <!--Column1-->
            <div class="footer-pad">
              <h4>Guide and Help</h4>
              <ul class="list-unstyled">
                <!-- <li><a href="#">Forums</a></li>
                <li><a href="#">Demo</a></li> -->
                <li><router-link to="support">Support</router-link></li>
                <li>
                  <router-link to="terms-and-conditions"
                    >Terms & Conditions</router-link
                  >
                </li>
                <!-- <li><router-link to="terms-and-conditions">Terms & Conditions</router-link></li>
                <li><router-link to="privacy-policy">Privacy Policy</router-link></li> -->
              </ul>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <!--Column1-->
            <div class="footer-pad">
              <h4>Contact Us</h4>
              <ul class="list-unstyled">
                <li>
                  <a href="https://web.facebook.com/ilovezed" target="_blank"
                    >Facebook</a
                  >
                </li>
                <!-- <li><a href="#">Twitter</a></li>
                <li><a href="#">Instagram</a></li>
                <li><a href="#">Facebook</a></li> -->
              </ul>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-pad">
              <h4>Follow Us</h4>
              <ul class="social-network social-circle">
                <li>
                  <a
                    href="https://web.facebook.com/ilovezed"
                    target="_blank"
                    class="icoFacebook"
                    title="Facebook"
                  >
                    <i><fa-icon :icon="['fab', 'facebook']" /></i
                  ></a>
                </li>
                <!-- <li>
                  <a href="#" class="icoInstagram" title="Instagram">
                    <i><fa-icon :icon="['fab', 'instagram']" /></i
                  ></a>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 copy">
            <p class="text-center">
              &copy; Copyright 2021 - Funbox PH. All rights reserved.
            </p>
            <p class="text-center version-display">ver. {{ version }}</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
};
</script>
